<template>
  <div v-bind="$attrs">
    <div class="mb-2 d-flex">
      <div
        class="pr-1"
        style="flex-grow: 1; font-size: 16px; align-self: center"
      >
        <b>{{ texts.subheader }}</b>
      </div>
      <div class="text-end" style="align-self: center">
        <v-btn-icon
          icon
          color="edit-green"
          class="ma-0"
          size="small"
          :aria-label="$t('common:editButton.alt')"
          @click="openForm"
        >
          <v-icon color="white" size="small"> $edit </v-icon>
        </v-btn-icon>
      </div>
    </div>

    <div>
      <v-icon v-if="entity.internalNote" color="primary" class="mr-1">
        $iconCommentDots
      </v-icon>
      {{ truncatedNote }}
    </div>
  </div>

  <AppDialogContent
    v-model="noteModal"
    :persistent="submitted"
    @submit-form="handleSubmit"
  >
    <template #header>
      {{ texts.modalHeader }}
    </template>

    <v-textarea
      v-model="noteForm"
      :label="texts.label"
      :hint="texts.hint"
      persistent-hint
      variant="outlined"
    />
  </AppDialogContent>
</template>
<script>
import gql from "fraql";
import AppDialogContent from "@elements/AppDialogContent.vue";
import { truncate } from "lodash-es";

export default {
  name: "AppEntityNote",
  components: { AppDialogContent },
  props: {
    note: {
      type: String,
      default: null
    },
    entityType: {
      type: String,
      required: true
    },
    entity: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      noteModal: false,
      noteForm: null,
      submitted: false
    };
  },
  computed: {
    texts() {
      switch (this.entityType) {
        case "PERSON":
          return {
            subheader: this.$t(
              "people:personPage.additionalInformation.subheading",
              "Additional information"
            ),
            modalHeader: this.$t(
              "people:personPage.internalCommentModal.heading",
              "Internal comment on person"
            ),
            label: this.$t(
              "people:personPage.internalCommentModal.label",
              "Internal comment"
            ),
            hint: this.$t(
              "people:personPage.internalCommentModal.hint",
              "Add or edit internal comment - it will be visible only for administrators of the system."
            )
          };
        case "HORSE":
          return {
            subheader: this.$t(
              "horses:horseProfilePage.additionalInformation.subheading",
              "Additional information"
            ),
            modalHeader: this.$t(
              "horses:horseProfilePage.internalCommentModal.heading",
              "Internal comment on horse"
            ),
            label: this.$t(
              "horses:horseProfilePage.internalCommentModal.label",
              "Internal comment"
            ),
            hint: this.$t(
              "horses:horseProfilePage.internalCommentModal.hint",
              "Add or edit internal comment - it will be visible only for administrators of the system."
            )
          };
        default:
          return {};
      }
    },
    mutationName() {
      switch (this.entityType) {
        case "PERSON":
          return "personCreateOrUpdate";
        case "HORSE":
          return "horseCreateOrUpdate";
        default:
          return {};
      }
    },
    truncatedNote() {
      return truncate(this.entity.internalNote, {
        length: 20
      });
    }
  },
  methods: {
    openForm() {
      this.noteForm = this.entity.internalNote;
      this.noteModal = true;
    },
    async handleSubmit() {
      this.submitted = true;

      try {
        this.noteModal = false;
        await this.$apollo.mutate({
          mutation: gql`
            mutation ${this.mutationName}(
              $id: ID!
              $internalNote: String
            ) {
              ${this.mutationName}(input: {
                id: $id
                internalNote: $internalNote
              }) {
                ${this.entityType.toLowerCase()} {
                  id
                  internalNote
                }
              } 
            }
          `,
          variables: {
            id: this.entity.id,
            internalNote: this.noteForm
          }
        });

        this.noteModal = false;
      } catch (error) {
        this.$root.$snackbarServerError(error, { level: "error" });
      } finally {
        this.submitted = false;
      }
    }
  },
  fragments: {
    horseFields: gql`
      fragment _ on Horse {
        id
        internalNote
      }
    `,
    personFields: gql`
      fragment _ on Person {
        id
        internalNote
      }
    `
  }
};
</script>
